import { Box, Grid } from '@mui/material';
import SearchModal from '../../../SearchModal';
import ParamsPicklist from '../../../../Types/ParamsPicklist';
import { useState } from 'react';
import { SalamComptaAgenceDto } from '../../../../Models/ParamsSalam';

// Composants MUI pour le tableau
import {
  Button, Dialog, DialogContent, DialogActions, Fade, LinearProgress,
  Stack, IconButton, Paper, Typography,
  Tooltip, Divider, Alert
} from '@mui/material';
import { ColumnsType } from 'antd/es/table';
import Table from '../../../TableResizable';
import SelectOption from '../../../SelectOption';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import CloseIcon from '@mui/icons-material/Close';
import SaveIcon from '@mui/icons-material/Save';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

// Recherche plan comptable
let searchPlancp: ParamsPicklist = {
  CodeAgence: '',
  Table: "PLANCP",
  Colonne1: "IDPLAN",
  Colonne2: "LIBELL",
  Choix: 22
};

// Recherche agence
const searchAgence: ParamsPicklist = {
  CodeAgence: '', Table: "Agence", Colonne1: "CODAGE", Colonne2: "LIBELLE", Colagence: '101', Choix: 22
};

const makeSearchParamsCompte = (agence: string): ParamsPicklist => ({
  CodeAgence: agence, Table: "COMPTES", Colonne1: "NUMCPT", Colonne2: "NOMCPT",
  Colagence: 'AGCCPT', Choix: 22, colfiltre: 'TYPCPT', valfiltre: 'I'
});

// Colonnes du tableau des comptes par agence
const COLUMNS = [
  { key: 'CodeAgence', label: 'Agence', width: 100 },
  { key: 'CompteStockTransit', label: 'Avance Salam', width: 140 },
  { key: 'CompteStockReel', label: 'Stock Réel', width: 120 },
  { key: 'CompteProfit', label: 'Marge différée', width: 120 },
  { key: 'CompteCharity', label: 'Charity', width: 120 },
  { key: 'CompteTvaDifferee', label: 'TVA Différée', width: 120 },
  { key: 'CompteTvaCollecte', label: 'TVA Collectée', width: 120 },
];

const thStyle: React.CSSProperties = {
  fontWeight: 700, fontSize: 11, color: '#fff', backgroundColor: '#2A6596',
  letterSpacing: 0.4, textTransform: 'uppercase', whiteSpace: 'nowrap',
};

interface Tab2Props {
  form?: any;
  etatG?: boolean;
  comptaAgences?: SalamComptaAgenceDto[];
  setComptaAgences?: React.Dispatch<React.SetStateAction<SalamComptaAgenceDto[]>>;
}

const Tab2 = (props: Tab2Props) => {
  const [editingRow, setEditingRow] = useState<SalamComptaAgenceDto | null>(null);
  const [modalForm, setModalForm] = useState<SalamComptaAgenceDto>({
    CodeAgence: '',
    CompteStockTransit: '',
    CompteStockReel: '',
    CompteProfit: '',
    CompteCharity: '',
    CompteTvaDifferee: '',
    CompteTvaCollecte: ''
  });
  const [openModal, setOpenModal] = useState(false);
  const [saving, setSaving] = useState(false);

  const agences = props.comptaAgences ?? [];

  const handleField = (field: keyof SalamComptaAgenceDto, value: string) => {
    setModalForm(prev => ({ ...prev, [field]: value }));
  };

  const isFormValid = () => {
    return modalForm.CodeAgence && modalForm.CompteStockTransit && modalForm.CompteStockReel;
  };

  // ✅ Utilisation de resetFields pour vider correctement le SelectOption
  const handleChangeAgence = () => {
    props.form?.resetFields([
      "CompteStockTransit",
      "CompteStockReel",
      "CompteProfit",
      "CompteCharity",
      "CompteTvaDifferee",
      "CompteTvaCollecte"
    ]);
  };

  const handleOpenAdd = () => {
    setEditingRow(null);
    setModalForm({
      CodeAgence: '',
      CompteStockTransit: '',
      CompteStockReel: '',
      CompteProfit: '',
      CompteCharity: '',
      CompteTvaDifferee: '',
      CompteTvaCollecte: ''
    });
    
    // ✅ Réinitialisation complète du formulaire pour l'ajout
    props.form?.resetFields([
      "CodeAgence",
      "CompteStockTransit",
      "CompteStockReel",
      "CompteProfit",
      "CompteCharity",
      "CompteTvaDifferee",
      "CompteTvaCollecte"
    ]);
    
    setOpenModal(true);
  };

  const handleOpenEdit = (row: SalamComptaAgenceDto) => {
    setEditingRow(row);
    setModalForm({ ...row });
    
    // ✅ Remplissage du formulaire Ant Design pour la modification
    props.form?.setFieldsValue({
      CodeAgence: row.CodeAgence,
      CompteStockTransit: row.CompteStockTransit,
      CompteStockReel: row.CompteStockReel,
      CompteProfit: row.CompteProfit,
      CompteCharity: row.CompteCharity,
      CompteTvaDifferee: row.CompteTvaDifferee,
      CompteTvaCollecte: row.CompteTvaCollecte
    });

    setOpenModal(true);
  };

  const handleClose = () => {
    setOpenModal(false);
    setEditingRow(null);
    setSaving(false);
  };

  const handleSave = () => {
    if (!props.setComptaAgences) return;
    setSaving(true);
    setTimeout(() => {
      if (editingRow) {
        props.setComptaAgences!(prev =>
          prev.map(a => a.CodeAgence === editingRow.CodeAgence ? modalForm : a)
        );
      } else {
        if (agences.some(a => a.CodeAgence === modalForm.CodeAgence)) {
          alert("Cette agence est déjà configurée.");
          setSaving(false);
          return;
        }
        props.setComptaAgences!(prev => [...prev, modalForm]);
      }
      setSaving(false);
      handleClose();
    }, 400);
  };

  const handleDelete = (agenceCode: string) => {
    if (props.setComptaAgences) {
      props.setComptaAgences(prev => prev.filter(a => a.CodeAgence !== agenceCode));
    }
  };

  // ── Colonnes du tableau (redimensionnables en tirant la bordure de l'en-tête) ──
  const glColumns: ColumnsType<SalamComptaAgenceDto> = [
    ...COLUMNS.map((col) => ({
      title: col.label,
      dataIndex: col.key,
      width: col.width,
      ellipsis: true,
      onHeaderCell: () => ({ style: thStyle }),
      onCell: () => ({ style: { fontSize: 12, color: '#2d4a5e' } }),
      render: (v: any) => v || <span style={{ color: '#bbb', fontStyle: 'italic' }}>—</span>,
    })),
    {
      title: 'Actions',
      key: 'actions',
      width: 90,
      align: 'center' as const,
      onHeaderCell: () => ({ style: thStyle }),
      render: (_: any, row: SalamComptaAgenceDto) => (
        <Stack direction="row" spacing={0.5} justifyContent="center">
          <Tooltip title="Modifier les comptes">
            <IconButton size="small" onClick={() => handleOpenEdit(row)}
              sx={{ bgcolor: '#e8f0fe', color: '#2A6596', '&:hover': { bgcolor: '#2A6596', color: '#fff' }, width: 28, height: 28 }}>
              <EditIcon sx={{ fontSize: 15 }} />
            </IconButton>
          </Tooltip>
          <Tooltip title="Supprimer">
            <IconButton size="small" onClick={() => handleDelete(row.CodeAgence)}
              sx={{ bgcolor: '#fdecea', color: '#c0392b', '&:hover': { bgcolor: '#c0392b', color: '#fff' }, width: 28, height: 28 }}>
              <DeleteIcon sx={{ fontSize: 15 }} />
            </IconButton>
          </Tooltip>
        </Stack>
      ),
    },
  ];

  return (
    <div className="tabItem">
      <Box fontStyle="inherit" className="border" width={"85%"} position={"absolute"}>
        {/* Section Plans comptables */}
        <Box className="border-left" mb={3}>
          <Typography variant="subtitle1" fontWeight="bold" color="#04446e" mb={2} sx={{ pl: 1 }}>
            Plans comptables (IDPL)
          </Typography>
          <Grid container spacing={0}>
            <Grid item xs={12} md={6}>
              <SearchModal
                width={7}
                Titre="Plan d'engagement"
                Parametre={searchPlancp}
                label="Plan d'engagement"
                name="IDPLENG"
                form={props.form}
                notRequired
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <SearchModal
                width={7}
                Titre="Plan impayé"
                Parametre={searchPlancp}
                label="Plan impayé"
                name="IDPLIMPAYE"
                form={props.form}
                notRequired
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <SearchModal
                width={7}
                Titre="Plan fonds garantie"
                Parametre={searchPlancp}
                label="Plan fonds garantie"
                name="IDPLFONDGAR"
                form={props.form}
                notRequired
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <SearchModal
                width={7}
                Titre="Plan créance immo"
                Parametre={searchPlancp}
                label="Plan créance immo"
                name="IDPLCRIMMO"
                form={props.form}
                notRequired
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <SearchModal
                width={7}
                Titre="Plan pénalité impayée"
                Parametre={searchPlancp}
                label="Plan pénalité impayée"
                name="IDPLPENIMP"
                form={props.form}
                notRequired
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <SearchModal
                width={7}
                Titre="Plan créance douteuse"
                Parametre={searchPlancp}
                label="Plan créance douteuse"
                name="IDPLCRDOUT"
                form={props.form}
                notRequired
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <SearchModal
                width={7}
                Titre="Plan promesse"
                Parametre={searchPlancp}
                label="Plan promesse"
                name="IDPLPROMESS"
                form={props.form}
                notRequired
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <SearchModal
                width={7}
                Titre="Plan provision"
                Parametre={searchPlancp}
                label="Plan provision"
                name="IDPLPROV"
                form={props.form}
                notRequired
              />
            </Grid>
          </Grid>
        </Box>

        {/* Section Comptes par agence */}
        <Box sx={{
          mt: 1, borderRadius: '12px',
          border: '1px solid #e3edf7', overflow: 'hidden',
          boxShadow: '0 2px 12px rgba(4,68,110,0.08)',
        }}>
          <Box sx={{
            px: 3, py: 1.8,
            background: 'linear-gradient(135deg, #04446e 0%, #2A6596 100%)',
            display: 'flex', alignItems: 'center', justifyContent: 'space-between',
          }}>
            <Stack direction="row" alignItems="center" spacing={1.5}>
              <AccountBalanceIcon sx={{ color: '#B0D2F7', fontSize: 22 }} />
              <Box>
                <Typography sx={{ color: '#fff', fontWeight: 700, fontSize: 14, letterSpacing: 0.3 }}>
                  Comptes Salam par Agence
                </Typography>
                <Typography sx={{ color: '#B0D2F7', fontSize: 11 }}>
                  {agences.length} configuration{agences.length !== 1 ? 's' : ''}
                </Typography>
              </Box>
            </Stack>
            <Button
              disabled={!props.etatG}
              variant="contained" size="small"
              startIcon={<AddCircleOutlineIcon />}
              onClick={handleOpenAdd}
              sx={{
                bgcolor: '#B0D2F7', color: '#04446e', fontWeight: 700,
                fontSize: 12, px: 2, borderRadius: '8px', textTransform: 'none',
                '&:hover': { bgcolor: '#fff', color: '#04446e' },
              }}
            >
              Associer une agence
            </Button>
          </Box>

          {/* Table (colonnes redimensionnables, pagination moderne) */}
          <Table
            size="small"
            rowKey="CodeAgence"
            columns={glColumns}
            dataSource={agences}
            scroll={{ y: 260, x: 'max-content' }}
            locale={{
              emptyText: (
                <Box sx={{ py: 5, textAlign: 'center' }}>
                  <AccountBalanceIcon sx={{ fontSize: 40, color: '#c5d8ea', mb: 1 }} />
                  <Typography sx={{ color: '#90a4b7', fontSize: 13 }}>
                    Aucune configuration. Cliquez sur <b>« Associer une agence »</b>.
                  </Typography>
                </Box>
              ),
            }}
            pagination={agences.length > 0 ? {
              defaultPageSize: 5,
              pageSizeOptions: [5, 10, 25],
              showSizeChanger: true,
              showTotal: (total, range) => `${range[0]}-${range[1]} sur ${total} configuration(s)`,
              size: 'small',
              style: { marginRight: 16 },
            } : false}
          />
        </Box>
      </Box>

      {/* Dialogue d'ajout/modification des comptes */}
      <Dialog
        open={openModal} onClose={handleClose}
        maxWidth="md" fullWidth
        TransitionComponent={Fade}
        PaperProps={{ sx: { borderRadius: '16px', overflow: 'hidden', boxShadow: '0 20px 60px rgba(4,68,110,0.18)' } }}
      >
        <Box sx={{
          px: 3, py: 2,
          background: 'linear-gradient(135deg, #04446e 0%, #2A6596 100%)',
          display: 'flex', alignItems: 'center', justifyContent: 'space-between',
        }}>
          <Stack direction="row" spacing={1.5} alignItems="center">
            <AccountBalanceIcon sx={{ color: '#B0D2F7', fontSize: 24 }} />
            <Box>
              <Typography sx={{ color: '#fff', fontWeight: 700, fontSize: 15 }}>
                {editingRow ? 'Modifier les comptes Salam' : 'Nouvelle configuration comptable'}
              </Typography>
              <Typography sx={{ color: '#B0D2F7', fontSize: 11 }}>
                {editingRow
                  ? `Agence ${editingRow.CodeAgence} — modification des comptes`
                  : 'Associer les comptes Salam à une agence'}
              </Typography>
            </Box>
          </Stack>
          <IconButton onClick={handleClose} sx={{ color: '#B0D2F7', '&:hover': { color: '#fff' } }}>
            <CloseIcon />
          </IconButton>
        </Box>

        {saving && <LinearProgress sx={{ height: 3 }} />}

        <DialogContent sx={{ bgcolor: '#f7fafd', px: 3, pt: 3, pb: 1 }}>
          <Alert
            icon={<InfoOutlinedIcon fontSize="small" />} severity="info"
            sx={{ mb: 2.5, fontSize: 12, borderRadius: '8px', bgcolor: '#e8f4fd', color: '#2A6596', border: '1px solid #b3d4f0' }}
          >
            Les champs <b>Agence</b>, <b>Stock Transit</b> et <b>Stock Réel</b> sont obligatoires.
          </Alert>

          <Paper elevation={0} sx={{ p: 2, mb: 2, borderRadius: '10px', border: '1px solid #dce8f3', bgcolor: '#fff' }}>
            <Stack direction="row" alignItems="center" spacing={1} mb={0.5}>
              <Box sx={{ width: 6, height: 6, borderRadius: '50%', bgcolor: '#2A6596' }} />
              <Typography sx={{ fontWeight: 700, fontSize: 12, color: '#04446e', textTransform: 'uppercase', letterSpacing: 0.8 }}>
                Identification de l'agence
              </Typography>
            </Stack>
            <SelectOption
              Size="large"
              label={editingRow ? `Agence : ${editingRow.CodeAgence}` : "Sélectionner l'agence *"}
              name="CodeAgence"
              Parametre={searchAgence}
              onchange={(value: any) => {
                handleField('CodeAgence', value);
                handleChangeAgence();
              }}
              disabled={!!editingRow}
            />
            {editingRow && (
              <Typography sx={{ mt: 0.5, fontSize: 11, color: '#90a4b7', fontStyle: 'italic' }}>
                L'agence ne peut pas être modifiée — seuls les comptes sont éditables.
              </Typography>
            )}
          </Paper>

          <Paper elevation={0} sx={{ p: 2, borderRadius: '10px', border: '1px solid #dce8f3', bgcolor: '#fff' }}>
            <Stack direction="row" alignItems="center" spacing={1} mb={2}>
              <Box sx={{ width: 6, height: 6, borderRadius: '50%', bgcolor: '#00875A' }} />
              <Typography sx={{ fontWeight: 700, fontSize: 12, color: '#04446e', textTransform: 'uppercase', letterSpacing: 0.8 }}>
                Paramétrage des comptes Salam
              </Typography>
            </Stack>
            <Grid container spacing={0}>
              {[
                { field: 'CompteStockTransit', label: 'Stock Transit', required: true },
                { field: 'CompteStockReel', label: 'Stock Réel', required: true },
                { field: 'CompteProfit', label: 'Profit', required: false },
                { field: 'CompteCharity', label: 'Charity', required: false },
                { field: 'CompteTvaDifferee', label: 'TVA Différée', required: false },
                { field: 'CompteTvaCollecte', label: 'TVA Collectée', required: false },
              ].map(({ field, label, required }) => (
                <Grid item xs={12} sm={6} key={field}>
                  <Typography sx={{ fontSize: 11, fontWeight: 600, color: '#5a7a90', mb: 0 }}>
                    {label} {required && <span style={{ color: '#e53935' }}>*</span>}
                  </Typography>
                  <SelectOption
                    Size="large"
                    label=""
                    name={field}
                    Parametre={makeSearchParamsCompte(editingRow?.CodeAgence ?? modalForm.CodeAgence)}
                    onchange={(value: any) => handleField(field as keyof SalamComptaAgenceDto, value)}
                    disabled={!modalForm.CodeAgence && !editingRow}
                  />
                </Grid>
              ))}
            </Grid>
            {!modalForm.CodeAgence && !editingRow && (
              <Typography sx={{ mt: 1.5, fontSize: 11, color: '#90a4b7', fontStyle: 'italic', textAlign: 'center' }}>
                Sélectionnez d'abord une agence pour activer les comptes.
              </Typography>
            )}
          </Paper>
        </DialogContent>

        <Divider />
        <DialogActions sx={{ px: 3, py: 2, bgcolor: '#f7fafd', gap: 1 }}>
          <Button onClick={handleClose} variant="outlined" size="medium" startIcon={<CloseIcon />}
            sx={{ borderColor: '#c0392b', color: '#c0392b', borderRadius: '8px', textTransform: 'none', fontWeight: 600 }}>
            Annuler
          </Button>
          <Button onClick={handleSave} variant="contained" size="medium"
            disabled={!isFormValid() || saving}
            startIcon={editingRow ? <SaveIcon /> : <CheckCircleIcon />}
            sx={{ bgcolor: '#00875A', color: '#fff', borderRadius: '8px', textTransform: 'none', fontWeight: 700, px: 3 }}>
            {saving ? 'Enregistrement...' : editingRow ? 'Mettre à jour' : "Valider l'association"}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default Tab2;